/**
 * Tenant eczane yetki kimlikleri — backend TenantPermissionIds ile birebir.
 * Yeni API/görünürlük zorunlu izin: buraya + TenantPermissionIds.cs + endpoint/FE +
 * permissionCatalog DEFAULT_PERMISSIONS birlikte. Katalogda uygulanmayan id tutulmaz.
 */
export const TENANT_PERMISSION_IDS = {
  financePageView: 'finance_page_view',
  dashboardFinancialView: 'dashboard_financial_view',
  /** Satış geçmişinden düzenleme (correctedFromSaleId ile complete). */
  salesEdit: 'sales_edit',
  /** Satış geçmişinden iade (POST .../sales/{id}/return) ve sepet iade satırı complete. */
  salesRefund: 'sales_refund',
  /** Yeni satış tamamlama (complete; düzenleme hariç). */
  salesCreate: 'sales_create',
  /** Satış geçmişi liste / detay. */
  salesView: 'sales_view',
  /** Satış iskontosu (complete gövdesinde Discount / kalem discountRate). */
  salesDiscount: 'sales_discount',
  /** Stok listesi / miat-hareketsiz görüntüleme. */
  stockView: 'stock_view',
  /** Stok girişi / import (düzeltme hariç). */
  stockAdd: 'stock_add',
  /** Stok sayım / düzeltme (CORRECTION). */
  stockEdit: 'stock_edit',
  /** Kullanıcı yönetimi sayfası + personel listesi. */
  userManagementPage: 'user_management_page',
  /** Yeni personel. */
  userCreate: 'user_create',
  /** Personel güncelleme / rol / şifre / durum. */
  userEdit: 'user_edit',
  /** Personel silme. */
  userDelete: 'user_delete',
  /** Rol izinlerini yönetme. */
  permissionsManage: 'permissions_manage',
  /** Rol oluşturma / düzenleme / silme. */
  roleManage: 'role_manage',
  /** Ayarlar sayfası. */
  settingsView: 'settings_view',
  /** Ayar kaydı (PUT). */
  settingsEdit: 'settings_edit',
  /** Depo faturası sayfası / liste / çekme. */
  depotView: 'depot_view',
  /** Depo faturası kaydet / manuel / iptal. */
  depotSave: 'depot_save',
  /** Emanet listesi. */
  emanetView: 'emanet_view',
  /** Emanet kapanış / not / silme. */
  emanetManage: 'emanet_manage',
  /** Veresiye listesi. */
  veresiyeView: 'veresiye_view',
  /** Veresiye kapanış / manuel borç / not / silme. */
  veresiyeManage: 'veresiye_manage',
  /** Ürün listesi sayfası (/productslist). Satış ürün araması buna bağlı değil. */
  productsView: 'products_view',
  /** Yeni ürün ekleme isteği (yönetici onayı). */
  productsCreate: 'products_create',
  /** PSF değiştirme (alt kullanıcıda eczacı onayına gider). */
  productsEditPrice: 'products_edit_price',
  /** Takas sayfaları / hareket listesi. */
  takasView: 'takas_view',
  /** Takas al/ver, iptal, düzenleme, partner. */
  takasManage: 'takas_manage',
  /** Hasta listesi dizini (/hasta/liste). Satış hasta araması buna bağlı değil. */
  patientsView: 'patients_view',
  /** Hasta güncelleme / silme / geri alma. Hızlı ekleme ve telefon toplama ayrı. */
  patientsManage: 'patients_manage',
  /** Aktivite günlüğü sayfası ve liste. */
  activityLogView: 'activity_log_view',
  /** KKİ listesi / dışa aktarma. Sepet lookup ayrı. */
  kkiView: 'kki_view',
  /** Ajanda görüntüleme. */
  agendaView: 'agenda_view',
  /** Ajanda oluştur / düzenle / sil. */
  agendaManage: 'agenda_manage',
  /** İlaç takibi listesi. */
  ilacTakibiView: 'ilac_takibi_view',
  /** İlaç takibi durumu değiştirme. */
  ilacTakibiManage: 'ilac_takibi_manage',
  /** Reçete listesi / detay / silme. Medula kayıt ayrı. */
  prescriptionsView: 'prescriptions_view',
  /** Reçetem portalı. */
  recetemView: 'recetem_view',
  /** İTS Paydaş Portalı. Satış bildirimleri ayrı. */
  itsPortalView: 'its_portal_view',
  /** CETAS entegrasyonu. */
  cetasView: 'cetas_view',
} as const

export type TenantPermissionId = (typeof TENANT_PERMISSION_IDS)[keyof typeof TENANT_PERMISSION_IDS]
